import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: WateringCreateInput!
  ) {
    createOneWatering(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Rega criada`, mutationTypes.CREATE)
)
